import { Injectable } from '@angular/core';

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class FacebookPixelService {

  private loadOk: boolean = false;
  private pixelCode: string | null = null;

  constructor() { }

  load(code: string): void {
    if (this.loadOk) {
      this.trackPageView();
      return;
    }

    if (typeof window.fbq !== 'undefined') {
      window.fbq('init', code);
      window.fbq('track', 'PageView');
      this.loadOk = true;
      this.pixelCode = code;
      console.log('Facebook Pixel já estava presente. Inicializado e PageView enviado.');
      return;
    }

    try {
      (function (f: any, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Node) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      window.fbq!.disablePushState = true;
      window.fbq!('init', code);
      window.fbq!('track', 'PageView');
      this.loadOk = true;
      this.pixelCode = code;
      console.log('Facebook Pixel carregado e PageView enviado!');
    } catch (error) {
      console.warn('Facebook Pixel falhou ao carregar:', error);
    }
  }

  trackPageView(): void {
    if (this.loadOk && typeof window.fbq !== 'undefined') {
      window.fbq('track', 'PageView');
      console.log('Facebook Pixel - PageView disparado.');
    }
  }

  track(eventName: string, eventData?: any): void {
    if (this.loadOk && typeof window.fbq !== 'undefined') {
      window.fbq('track', eventName, eventData || {});
      console.log(`Facebook Pixel - Evento '${eventName}' enviado`, eventData || {});
    }
  }
}
